var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container wrap"},[_c('rankBox',{staticClass:"rank1"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }